import tierQueries from '@apis/queries/tierQueries';
import { useQuery } from '@tanstack/react-query';

function useCalculationCycles() {
    const { data, isFetching } = useQuery(tierQueries.cycles());
    return {
        data, isFetching,
    };
}

export default useCalculationCycles;
